import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, SimpleChange } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { IOption } from '@shared/models/icommons.model';

@Component({
  selector: 'miq-sub-selection',
  templateUrl: './sub-selection.component.html',
  styleUrls: ['./sub-selection.component.scss'],
  standalone: false,
})
export class SubSelectionComponent implements OnInit, OnChanges {
  public selectAllFields = false;
  @Input() selectedFilter: string;
  @Input() subSectionList: IOption[];
  @Input() InputLength: number;
  @Input() editPermissionList: number[];
  @Output() selectedProperty = new EventEmitter<any>();
  public subSelectionArray: IOption[] = [];

  ngOnInit() {
    if (this.editPermissionList && this.subSectionList) {
      this.subSectionList.forEach(item => {
        if (this.editPermissionList.includes(item.key)) {
          item.checked = true;
          this.subSelectionArray.push(item);
        }
      });
      this.selectAllFields = this.subSectionList.every(item => item.checked) ? true : false;
    }
  }

  private _isNotFirstChangeAndHasLength(change: SimpleChange): boolean {
    return !change.firstChange && change.currentValue && change.currentValue.length > 0;
  }
  ngOnChanges(change: SimpleChanges) {
    if (
      this._isNotFirstChangeAndHasLength(change.editPermissionList) ||
      this._isNotFirstChangeAndHasLength(change.subSectionList)
    ) {
      this.ngOnInit();
    }
  }

  public onSelectionChange(item, event) {
    if (event.checked) {
      this.subSelectionArray.push(item);
    } else {
      this.selectAllFields = false;
      this.subSelectionArray.forEach((geoLocation, index) => {
        if (geoLocation.key === item.key) {
          this.subSelectionArray.splice(index, 1);
        }
      });
    }
    this.selectedProperty.emit(this.subSelectionArray);
  }

  public selectAll(evt: MatCheckboxChange) {
    const { checked: isChecked } = evt;
    this.subSelectionArray = [];
    this.subSectionList.forEach(object => {
      object.checked = isChecked;
    });
    this.selectAllFields = isChecked;
    if (isChecked) {
      this.subSelectionArray = JSON.parse(JSON.stringify(this.subSectionList));
      this.selectedProperty.emit(this.subSelectionArray);
    } else {
      this.selectedProperty.emit([]);
    }
  }
}
